import React, { useEffect, useRef } from "react"
import "react-datepicker/dist/react-datepicker.css"
import Svg from "../../shared/_svgs/svg"
import Truncate from "react-truncate"
import SimpleErrorModal from "../../shared/modal/simple-error-modal"
import "../../helpers/strings"
import { parkingState } from "../zustand/parkingState"
import { ParkingDatePicker } from "./ParkingDatePicker"

const BookingStarter = ({
  backgroundColor,
  backgroundUrl,
  bottomPadding,
  button,
  buttonClasses,
  buttonFontColor,
  campaignCode,
  disclaimer,
  flow,
  fontColor,
  formClasses,
  headline,
  history,
  inlineColor,
  isInModal,
  modifiers,
  noHeader,
  noneInverted,
  searchOnBlur,
  slimVersion,
  subHeadline,
  svgIcon,
  teaser,
  textKeys,
  tooltipHeadline,
  tooltipPreview,
  tooltipReadMore,
  tooltipText,
  topPadding,
  wide,
}) => {
  const containerRef = useRef(null)

  useEffect(() => {
    parkingState.getState().setInitialValues({
      campaignCodePromptActive: true,
      showTooltip: false,
      tooltipData: null,
    })
  }, [])

  const { campaignCodePromptActive, showTooltip, tooltipData } = parkingState((state) => ({
    campaignCodePromptActive: state.campaignCodePromptActive,
    showTooltip: state.showTooltip,
    tooltipData: state.tooltipData,
  }))

  const openTooltipModal = () => {
    parkingState.setState({ showTooltip: true, tooltipData: { h3: tooltipHeadline, richText: tooltipText } })
  }

  let buttonModifiers = ""

  if (buttonClasses) {
    buttonModifiers += buttonClasses + " "
  }
  if (!slimVersion) {
    buttonModifiers += " button--general button--large"
  }
  if (flow) {
    buttonModifiers += " button--general-inverted"
  }
  if (isInModal) {
    buttonModifiers += " button-general-inverted"
  }
  if (slimVersion) {
    buttonModifiers += " button--medium button--general-inverted"
  }

  if (noneInverted) {
    buttonModifiers = "button--medium button--general"
  }

  const handleModalClose = () => parkingState.setState({ showTooltip: false })

  return (
    <div
      className={`parking-time-picker js--parking-time-picker ${slimVersion ? "parking-time-picker--slim" : ""} ${
        modifiers || ""
      } ${campaignCodePromptActive ? "parking-time-picker--campaigncode-active" : ""}`}
      style={{
        backgroundImage: backgroundUrl ? `url(${backgroundUrl})` : "",
        color: inlineColor || "",
      }}
    >
      <div
        className={`parking-starter-container ${wide && !teaser ? "w--wide" : teaser ? "w--wider" : "w--normal"} ${backgroundColor} ${bottomPadding || "deck--padding-bottom-slim"} ${topPadding || "deck--padding-top-slim"}`}
        ref={containerRef}
      >
        {!noHeader ? (
          <div className="parking-time-picker__header">
            {svgIcon ? (
              <span className="icon">
                <svg className={`svg-icon svg-icon--${svgIcon}`}>
                  <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref={`/dist/svg/symbols.svg#svg-${svgIcon}`}>
                    &nbsp;
                  </use>
                </svg>
              </span>
            ) : null}
            <h2 className={`${fontColor ? `${fontColor}` : ""}`} dangerouslySetInnerHTML={{ __html: headline }}></h2>
            {subHeadline ? <p className={`${fontColor ? `${fontColor}` : ""}`}>{subHeadline}</p> : undefined}
          </div>
        ) : (
          ""
        )}

        <ParkingDatePicker textKeys={textKeys} flow={flow} isInModal={isInModal} history={history} buttonModifiers={buttonModifiers} />

        {tooltipHeadline && tooltipText && tooltipPreview && tooltipReadMore ? (
          <button className={"parking-time-picker__tooltip"} onClick={openTooltipModal}>
            <Svg iconName={"deliveryquestion"} fillColor={"#FFF"} />
            <div className={"tooltip-text"}>
              <Truncate lines={2} ellipsis={tooltipReadMore} width={250}>
                {tooltipPreview}
              </Truncate>
            </div>
          </button>
        ) : null}
        {disclaimer ? (
          <p
            className={`parking-time-picker__disclaimer ${tooltipHeadline && tooltipText && tooltipPreview && tooltipReadMore ? "more-top-margin" : ""}`}
          >
            {textKeys?.disclaimer || "Begrænsede antal pladser til denne pris"}
          </p>
        ) : null}
        {showTooltip ? <SimpleErrorModal errorData={tooltipData} modalOpen={true} closeHandler={handleModalClose} /> : ""}
      </div>
    </div>
  )
}

export default BookingStarter
